export default __webpack_public_path__ + "static/media/passport.21d40fb4.svg";